import React from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classes from "./Toastr.scss";
import PropTypes from "prop-types";
import { Alert } from "@toddle-edu/ds-web";

const toastPosition = {
  "toast-bottom-right": "bottom-right",
  "toast-bottom-left": "bottom-left",
  "toast-bottom-center": "bottom-center",
  "toast-top-center": "top-center",
};

const ToastComponent = ({
  closeToast,
  type = "warning",
  variant = "toast",
  title,
  message,
  isClosable,
  containerStyle,
  showIcon = true,
  actions,
  prefixIcon,
}) => {
  return (
    <Alert
      dsVersion="2.0"
      type={type}
      message={message}
      isClosable={isClosable}
      variant={variant}
      onClose={closeToast}
      title={title}
      style={containerStyle}
      showIcon={showIcon}
      actionElement={actions}
      prefixIcon={prefixIcon}
    />
  );
};

class Toastr extends React.PureComponent {
  showToast = ({ timeOut, isClosable = false, ...rest }) => {
    toast(<ToastComponent isClosable={isClosable} {...rest} />, {
      autoClose: isClosable ? 30000 : timeOut,
      transition: Slide,
      className: classes.toast,
      containerId: "generic-toast-message",
    });
  };

  render() {
    return (
      <div className={classes.toastr}>
        <ToastContainer
          hideProgressBar={true}
          closeButton={false}
          className={classes.toastContainer}
          bodyClassName={classes.toastBody}
          position={toastPosition[this.props.position]}
          newestOnTop
          containerId="generic-toast-message"
          enableMultiContainer
        />
      </div>
    );
  }
}

Toastr.propTypes = {
  position: PropTypes.string,
  isClosable: PropTypes.bool,
};

Toastr.defaultProps = {
  position: "toast-bottom-right",
  isClosable: false,
};

export default Toastr;
